// extracted by mini-css-extract-plugin
module.exports = {"page-site-map":"site-map_page-site-map__SnsZy","shop-info-box":"site-map_shop-info-box__1R6wj","content":"site-map_content__tPTQV"};